module.exports = __webpack_public_path__ + "static/media/study 201107.6402d24b.png";